// Available app fonts. Curated list focused on Arabic readability —
// every option here covers the full Arabic glyph set + Latin so the
// app reads consistently in both languages.
//
// Each entry has:
//   id       — stable key persisted in localStorage
//   labelEn  — English display name (used in the picker)
//   labelAr  — Arabic display name
//   stack    — the full CSS font-family value; empty for "system",
//              which keeps the index.css default fallback chain
//   google   — Google Fonts URL query (without the api-version
//              prefix); null for "system" since we don't load
//              anything in that case
//
// The "system" option is intentionally first — it's the baseline
// (Cairo + native system fallbacks per index.css) and stays free of
// any external font download. Picking any other option triggers a
// lazy <link> injection into <head>.

export const APP_FONTS = [
  {
    id: 'system',
    labelEn: 'System Default',
    labelAr: 'الافتراضى',
    stack: '',
    google: null,
  },
  {
    id: 'cairo',
    labelEn: 'Cairo',
    labelAr: 'القاهرة',
    stack: "'Cairo', system-ui, sans-serif",
    google: 'family=Cairo:wght@400;500;600;700',
  },
  {
    id: 'tajawal',
    labelEn: 'Tajawal',
    labelAr: 'تجوال',
    stack: "'Tajawal', system-ui, sans-serif",
    google: 'family=Tajawal:wght@400;500;700',
  },
  {
    id: 'almarai',
    labelEn: 'Almarai',
    labelAr: 'المراعي',
    stack: "'Almarai', system-ui, sans-serif",
    google: 'family=Almarai:wght@400;700',
  },
  {
    id: 'ibm-plex-arabic',
    labelEn: 'IBM Plex Sans Arabic',
    labelAr: 'IBM Plex',
    stack: "'IBM Plex Sans Arabic', system-ui, sans-serif",
    google: 'family=IBM+Plex+Sans+Arabic:wght@400;500;600',
  },
  {
    id: 'noto-arabic',
    labelEn: 'Noto Sans Arabic',
    labelAr: 'نوتو',
    stack: "'Noto Sans Arabic', system-ui, sans-serif",
    google: 'family=Noto+Sans+Arabic:wght@400;500;700',
  },
  {
    id: 'reem-kufi',
    labelEn: 'Reem Kufi',
    labelAr: 'ريم كوفى',
    stack: "'Reem Kufi', system-ui, sans-serif",
    google: 'family=Reem+Kufi:wght@400;600;700',
  },
  {
    id: 'amiri',
    labelEn: 'Amiri (Serif)',
    labelAr: 'أميرى',
    stack: "'Amiri', serif",
    google: 'family=Amiri:wght@400;700',
  },
]

export const DEFAULT_FONT_ID = 'ibm-plex-arabic'
